import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import {
  PORTAL_PREFIX,
  PAGE_PORTAL_ORDERS_PURCHASE_LIST,
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoPurchaseOrderDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {t("no-purchase-order-detail-title", "Purchase Order not found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "no-purchase-order-detail-description",
          "The purchase order you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        variant="contained"
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() =>
          navigate(
            localizedPath(
              `/${PORTAL_PREFIX}/${PAGE_PORTAL_ORDERS_PURCHASE_LIST}`,
              language,
              defaultLang
            )
          )
        }
      >
        {t("no-purchase-order-detail-back-button", "Back to Purchase Orders")}
      </Button>
    </Box>
  );
};

export default NoPurchaseOrderDetailFound;
